export const LABELS = {
  DISPLAY_KEY: 'Display',
  SHOW_ICON_KEY: 'Show Icon',
  SHOW_TITLE_KEY: 'Show Title',
  SHOW_LABEL_KEY: 'Show Label',
  DATA_SOURCE_KEY: 'Data Source',
  TRAILING_ELEMENTS_KEY: 'Trailing Elements',
  INTERACTION_COMPONENTS_KEY: 'Interaction Components',
  COMPONENT_TITLE_KEY: 'Component Title',
  EMAIL_KEY: 'Email',
  SORTING_KEY: 'Sorting',
  PLACEHOLDER_KEY: 'Placeholder',
  DATA_FILTER_KEY: 'Data Filter',
  GROUPING_KEY: 'Grouping',
  COLORS_KEY: 'Colors',
  WIDTH_KEY: 'Width',
  COMPONENT_WIDTH_KEY: 'Component Width',
  MODAL_WIDTH_KEY: 'Modal Width',
  GAP_KEY: 'Gap',
  SIZING_KEY: 'Sizing',
  ASPECT_RATIO_KEY: 'Aspect Ratio',
  ALIGNMENT_KEY: 'Alignment',
  HOVER_EFFECT_KEY: 'Hover Effect',
  ACCEPTED_FILES_KEY: 'Accepted Files',
  COLOR_SELECTION_KEY: 'Color Selection',
  FILE_SELECTION_KEY: 'File Selection',
  FONT_SELECTION_KEY: 'Font Selection',
  MAX_FILES_KEY: 'Max. Files',
  CONTENT_ALIGNMENT_KEY: 'Content Alignment',
  CORNER_RADIUS_KEY: 'Corner Radius',
  MEDIA_ICON_KEY: 'Media Icon',
  ICON_COLOR_KEY: 'Icon Color',
  ICON_BACKGROUND_COLOR_KEY: 'Icon Background Color',
  TIMELINE_LINE_COLOR_KEY: 'Timeline Line Color',
  TEXT_HELP_KEY: 'Help Text',
  RATING_METADATA_KEY: 'Metadata',
  DIVIDER_KEY: 'Divider',
  DIVIDER_COLOR_KEY: 'Divider Color',
  MULTILINE_KEY: 'Multiline',
  ORIENTATION_KEY: 'Orientation',
  REVERSE_ORDER_KEY: 'Reverse Order',
  LAYOUT_KEY: 'Layout',
  TYPOGRAPHY_KEY: 'Typography',
  SPACING_KEY: 'Spacing',
  POSITION_KEY: 'Position',
  TOP_KEY: 'Top',
  RIGHT_KEY: 'Right',
  BOTTOM_KEY: 'Bottom',
  LEFT_KEY: 'Left',
  ELEVATION_KEY: 'Elevation',
  ACTION_KEY: 'Action',
  FOOTER_AREA_KEY: 'Footer Area',
  APP_FILTERS_KEY: 'App Filters',
  USER_SEARCH_KEY: 'User Search',
  HEADER_ELEMENTS_KEY: 'Header Elements',
  METADATA_KEY: 'Metadata',
  FOOTER_ELEMENTS_KEY: 'Footer Elements',
  VARIANTS_KEY: 'Variant',
  VIEW_KEY: 'View',
  SCREEN_SIZE_KEY: 'Screen Size',
  VARIANT_KEY: 'Variant',
  STICKY_LOCATION_KEY: 'Sticky Location',
  THUMBNAIL_ICON_KEY: 'Thumbnail Icon',
  TEXT_MANUPULATION_KEY: 'Text Transformation',
  TEXT_LINES_KEY: 'Text Lines',
  COLOR_SCHEME_KEY: 'Color Scheme',
  COLOR_KEY: 'Color',
  BUTTON_COLOR_KEY: 'Button Color',
  COLOR_SEQUENCE_KEY: 'Color Sequence',
  NUMBER_OF_ITEMS_KEY: 'Number of Items',
  DEFAULT_ITEMS_PER_PAGE_KEY: 'Default Items Per Page',
  CLUSTER_KEY: 'Cluster',
  DIMENSION_KEY: 'Sizing',
  MAP_OPTIONS_KEY: 'Map Options',
  ON_ITEM_CLICK_KEY: 'On Item Click',
  ICON_POSITION_KEY: 'Icon Position',
  BADGE_POSITION_KEY: 'Badge Position',
  BORDER_KEY: 'Border',
  CARD_KEY: 'Card',
  THUMBNAIL_KEY: 'Thumbnail',
  THUMBNAIL_CARD_KEY: 'Thumbnail (Image, Icon)',
  MEDIA_KEY: 'Media',
  MEDIA_CARD_KEY: 'Media (Image, Video URL, Icon)',
  FOOTER_TITLE_KEY: 'Footer Title',
  LEADING_BUTTON_KEY: 'Leading Button',
  ACTION_BUTTON_KEY: 'Action Button',
  LEADING_ACTION_BUTTON_KEY: 'Leading Action Button',
  TRAILING_ACTION_BUTTON_KEY: 'Trailing Action Button',
  TITLE_KEY: 'Title',
  SUB_TITLE_KEY: 'Sub Title',
  CONTENT_KEY: 'Content',
  SUPPORTING_TEXT_KEY: 'Supporting Text',
  COMPONENT_ALIGNMENT_KEY: 'Align Component',
  PAGINATION_ALIGNMENT_KEY: 'Pagination Alignment',
  GROUP_HEADER_ALIGNMENT: 'Group Header Alignment',
  STYLE_KEY: 'Style',
  COLUMNS_KEY: 'Columns',
  ROWS_KEY: 'Rows',
  COLUMN_KEY: 'Column',
  PAGINATION_KEY: 'Pagination',
  BADGE_METADATA: 'Badge Metadata',
  TRAILING_ELEMENT_TYPE_KEY: 'Trailing Element Type',
  ACTION_ICON_KEY: 'Action Icon',
  TOGGLE_SWITCH_KEY: 'Toggle Switch',
  TOGGLE_BOX_KEY: 'Toggle Box',
  CHECK_BOX_KEY: 'Check Box',
  MENU_KEY: 'Menu',
  ACTION_MENU_KEY: 'Action Menu',
  SWITCH_KEY: 'Switch',
  ICON_BUTTON_KEY: 'Icon Button',
  SWITCH_METADATA_KEY: 'Switch Metadata',
  DATA_COLUMN_KEY: 'Data Column',
  SWITCH_USER_SPECIFIC_KEY: 'Switch User Specific',
  SWITCH_ICON_KEY: 'Switch Icon',
  BUTTON_ICON_KEY: 'Button Icon',
  GROUP_BY_KEY: 'Group By',
  GROUP_TITLE_KEY: 'Group Title',
  GALLERY_KEY: 'Gallery',
  CAROUSEL_ARROWS: 'Carousel Arrows',
  CAROUSEL_INDICATORS: 'Carousel Indicators',
  IMAGE_KEY: 'Image',
  COORDINATES_KEY: 'Coordinates',
  MARKER_ICON_KEY: 'Marker Icon',
  HEADER_KEY: 'Header',
  FOOTER_LABEL_KEY: 'Footer Label',
  LINE1_KEY: 'Line 1',
  LINE2_KEY: 'Line 2',
  LINE3_KEY: 'Line 3',
  LINE4_KEY: 'Line 4',
  LINE5_KEY: 'Line 5',
  LINE6_KEY: 'Line 6',
  LINE7_KEY: 'Line 7',
  ENABLE_KEY: 'Enable',
  LEADING_KEY: 'Leading',
  TRAILING_KEY: 'Trailing',
  SELECT_MENU_KEY: 'Select menu created in Menu Tab',
  TRAILING_MENU_KEY: 'Trailing Menu',
  SUB_HEADER_KEY: 'Sub Header',
  DESCRIPTION_KEY: 'Description',
  AVATAR_KEY: 'Avatar',
  FILTER_KEY: 'Filter',
  MARKER_CLUSTERING_KEY: 'Marker Clustering',
  HEIGHT_KEY: 'Height',
  ON_BUBBLE_CLICK_KEY: 'On Info Bubble Click',
  FIELD_PADDING_KEY: 'Field Padding',
  PADDING_KEY: 'Padding',
  MARGIN_KEY: 'Margin',
  MEDIA_MARGIN_KEY: 'Media Margin',
  COMPONENT_TITLE_MARGIN_KEY: 'Component Title Margin',
  GROUP_HEADER_MARGIN_KEY: 'Group Header Margin',
  FOOTER_MARGIN_KEY: 'Footer Margin',
  CAPTION_KEY: 'Caption',
  TAG_KEY: 'Tag',
  GROUP_HEADER_KEY: 'Group Header',
  ENABLE_USER_SEARCH: 'Enable User Search',
  LOCATIONS_KEY: 'Locations',
  MAP_TYPE_CONTROL_KEY: 'Map Type Control',
  FULLSCREEN_CONTROL_KEY: 'Fullscreen Control',
  STREET_VIEW_CONTROL_KEY: 'Street View Control',
  ZOOM_CONTROL_KEY: 'Zoom Control',
  DEFAULT_ZOOM_KEY: 'Default Zoom',
  INFO_BUBBLE_KEY: 'Info Bubble',
  THICKNESS_KEY: 'Thickness',
  HEADING_KEY: 'Heading',
  ITEM_MENU_KEY: 'Item Menu',
  ACTIVE_KEY: 'Active',
  ICON_KEY: 'Icon',
  LABEL_KEY: 'Label',
  BADGE_KEY: 'Badge',
  PRIMARY_KEY: 'Primary',
  SECONDARY_KEY: 'Secondary',
  ON_PRIMARY_FAB_CLICK_KEY: 'On Primary FAB Click',
  ON_SECONDARY_FAB_CLICK_KEY: 'On Secondary FAB Click',
  ACTIVE_ICON_KEY: 'Active Icon',
  INACTIVE_ICON_KEY: 'Inactive Icon',
  DATA_TO_TOGGLE_KEY: 'Data to Toggle',
  TOGGLED_VARIANT_KEY: 'Toggled Variant',
  ON_CLICK_KEY: 'On Click',
  ADD_EVENT_KEY: 'Add Event',
  ON_CLICK_EVENT_KEY: 'On Click Event',
  DEFAULT_VIEW_KEY: 'Default View',
  AUTO_FIT_DAY_KEY: 'Auto Fit Day',
  SHOW_ADD_EVENT_KEY: 'Show Add Event',
  ICON_BADGE_KEY: 'Icon / Badge',
  FAB_KEY: 'FAB',
  SHADOW_KEY: 'Shadow',
  CHARTS_KEY: 'Charts',
  PIE_KEY: 'Pie',
  VALUES_KEY: 'Values',
  DEFAULT_VALUE_KEY: 'Default Value',
  SORT_BY_KEY: 'Sort By',
  SORT_ORDERING_KEY: 'Sort Ordering',
  ASCENDING_KEY: 'Ascending',
  DESCENDING_KEY: 'Descending',
  MAX_ITEMS_KEY: 'Max Items',
  LABELS_KEY: 'Labels',
  LEGEND_KEY: 'Legend',
  DOUGHNUT_KEY: 'Doughnut',
  ABBREVIATE_NUMBER_KEY: 'Abbreviate Number',
  COMPONENT_KEY: 'Component',
  COMPONENT_PADDING_KEY: 'Component Padding',
  ELEMENTS_KEY: 'Elements',
  BAR_KEY: 'Bar',
  SORT_KEY: 'Sort',
  SKEW_LABEL_KEY: 'Skew Label',
  X_AXIS_KEY: 'X-Axis',
  Y_AXIS_KEY: 'Y-Axis',
  FEATURES_KEY: 'Features',
  HORIZONTAL_KEY: 'Horizontal',
  VERTICAL_KEY: 'Vertical',
  BAR_STYLE_KEY: 'Bar Style',
  GROUPED_KEY: 'Grouped',
  STACKED_KEY: 'Stacked',
  LEGEND_GAP_KEY: 'Legend Gap',
  CONTAINERS_KEY: 'Containers',
  SECTION_KEY: 'Section',
  BACKGROUND_KEY: 'Background',
  COLOR_VARIANT_KEY: 'Color Variant',
  INFO_BUBBLE_COLOR_VARIANT_KEY: 'Info Bubble Color Variant',
  COLOR_MARKER_KEY: 'Marker Color Variant',
  BACKGROUND_COLOR_OPACITY_KEY: 'Background Color Opacity',
  OVERLAY_KEY: 'Overlay',
  BASE_COLOR_KEY: 'Base Color',
  TRANSPARANCY_KEY: 'Transparency',
  FORCE_EQUAL_HEIGHT_KEY: 'Force Equal Height',
  VERTICAL_ALIGNMENT_KEY: 'Vertical Alignment',
  HORIZONTAL_ALIGNMENT_KEY: 'Horizontal Alignment',
  ITEM_GAP_KEY: 'Item Gap',
  TABS_KEY: 'Tabs',
  TAB_KEY: 'Tab',
  TAB_ITEMS_KEY: 'Tab Items',
  OUTLINED_KEY: 'Outlined',
  OUTLINE_KEY: 'Outline',
  BUTTON_KEY: 'Button',
  COMPONENT_MARGIN_KEY: 'Component Margin',
  INPUT_KEY: 'Input',
  HELP_TEXT_KEY: 'Help Text',
  TEXT_FIELD_KEY: 'Text Field',
  TEXT_ICON_KEY: 'Text/Icon',
  DATA_INPUT_KEY: 'Data',
  VALUE_KEY: 'Value',
  CIRCLE_INDICATOR_KEY: 'Circle Indicator',
  CIRCLE_TRACK_KEY: 'Circle Track',
  MAIN_LABEL_KEY: 'Main Label',
  PREFIX_KEY: 'Prefix',
  SUFFIX_KEY: 'Suffix',
  LEADING_ICON_KEY: 'Leading Icon',
  TRAILING_ICON_KEY: 'Trailing Icon',
  VALIDATION_KEY: 'Validation',
  SHOW_VALIDATION_HELP_TEXT_KEY: 'Show Validation Help Text',
  SHOW_HELP_TEXT_KEY: 'Show Help Text',
  GENERAL_VALIDATION_KEY: 'General Validation',
  DATE_VALIDATION_KEY: 'Date Validation',
  TIME_VALIDATION_KEY: 'Time Validation',
  PATTERN_KEY: 'Pattern',
  MIN_CHARACTERS_KEY: 'Min. Characters',
  MAX_CHARACTERS_KEY: 'Max. Characters',
  REQUIRED_KEY: 'Required',
  MUST_BE_CHECK: 'Must be checked',
  MUST_BE_SWITCHED_ON: 'Must be switched on',
  SHOW_HIDE_KEY: 'Show / Hide',
  RADIO_BUTTON_KEY: 'Radio Button',
  OPTIONS_DATA_KEY: 'Options Data',
  OPTIONS_DATA_SOURCE_KEY: 'Options Data Source',
  OPTIONS_VALUE_KEY: 'Options Value',
  OPTIONS_VALUE_HELP_KEY:
    'The value that represents the option. This is the value that will be read. Each option must have a unique value.',
  OPTIONS_LABEL_KEY: 'Options Label',
  OPTIONS_LABEL_HELP_KEY:
    'The display text shown in the UI representing the option. If unspecified, the Options Value will be used.',
  CHECKBOX_KEY: 'Checkbox',
  DATA_KEY: 'Data',
  SELECTION_KEY: 'Selection',
  GET_OPTIONS_FROM_KEY: 'Get Options From',
  OPTIONS_KEY: 'Options',
  DISPLAY_AS_KEY: 'Display As',
  DISPLAY_AS_HELP_KEY:
    'The display text shown in the UI representing the option. If unspecified, the Options Value will be used.',
  DISPLAY_AS_ICON_KEY: 'Display As Icon',
  OPTIONS_SORTING_KEY: 'Options Sorting',
  OPTIONS_DATA_FILTER_KEY: 'Options Data Filter',
  SELECTION_TYPE_KEY: 'Selection Type',
  DROPDOWN_KEY: 'Dropdown',
  RADIO_KEY: 'Radio',
  CHIP_KEY: 'Chip',
  SEGMENTED_KEY: 'Segmented',
  MULTIPLE_KEY: 'Multiple',
  ALLOW_MULTIPLE_KEY: 'Allow Multiple',
  SEPARATOR_KEY: 'Separator',
  COMMA_KEY: 'Comma',
  SEMICOLON_KEY: 'Semicolon',
  COLON_KEY: 'Colon',
  DATETIME_PICKER_KEY: 'Date Time Picker',
  DATE_VALUE_KEY: 'Date Value',
  SLIDER_KEY: 'Slider',
  RANGE_KEY: 'Range',
  FIELD_KEY: 'Field',
  FIELD_BACKGROUND_KEY: 'Field Background',
  MARKING_KEY: 'Marking',
  STEP_MARK_KEY: 'Step Mark',
  MIN_VALUE_KEY: 'Min. Value',
  MAX_VALUE_KEY: 'Max. Value',
  STEP_KEY: 'Step',
  INTERACTIVE_KEY: 'Interactive',
  RATING_KEY: 'Rating',
  PROGRESS_BAR_KEY: 'Progress Bar',
  STOPWATCH_KEY: 'Stopwatch',
  ACCEPT_DATETIME_HELP_KEY: 'Accept column type Date & Time',
  DURATION_KEY: 'Duration',
  GENERAL_KEY: 'General',
  COUNTDOWN_TO_START_KEY: 'Countdown to Start',
  COUNTDOWN_SOUND_KEY: 'Countdown Sound',
  BELL_KEY: 'Bell',
  PING_KEY: 'Ping',
  SHOW_WARNING_ON_RESET_KEY: 'Show Warning on Reset',
  COMMENTS_KEY: 'Comments',
  COMMENT_KEY: 'Comment',
  PARENT_COMMENT_KEY: 'Parent Comment',
  USER_COMMENT_KEY: 'User Comment',
  AUTHOR_NAME_KEY: 'Author Name',
  AUTHOR_AVATAR_KEY: 'Author Avatar',
  DATE_KEY: 'Date',
  TIME_KEY: 'Time',
  START_DATE_KEY: 'Start Date',
  END_DATE_KEY: 'End Date',
  LIKES_KEY: 'Likes',
  DISLIKES_KEY: 'Dislikes',
  APPROVED_KEY: 'Approved',
  COUNTER_KEY: 'Counter',
  SHOW_LIKE_COUNT_KEY: 'Show Like Count',
  SHOW_DISLIKE_COUNT_KEY: 'Show Dislike Count',
  AUTO_APPROVE_KEY: 'Auto Approve',
  ON_LIKE_BUTTON_CLICK_KEY: 'On Like Button Click',
  LIKE_KEY: 'Like',
  DISLIKE_KEY: 'Dislike',
  VIDEO_KEY: 'Video',
  VIDEO_URL_KEY: 'Video URL',
  COVER_IMAGE_KEY: 'Cover Image',
  CONTROLS_KEY: 'Controls',
  PROGRESS_POSITION_KEY: 'Progress Position',
  VOLUME_CONTROL_KEY: 'Volume Control',
  CONTROL_KEY: 'Control',
  AUDIO_KEY: 'Audio',
  AUDIO_URL_KEY: 'Audio URL',
  ARRAY_GALLERY_KEY: 'Array Gallery',
  ITEMS_KEY: 'Items',
  GALLERY_HEADLINE_KEY: 'Gallery Headline',
  HEADLINE_KEY: 'Headline',
  CAROUSEL_ARROW_KEY: 'Carousel Arrow',
  CAROUSEL_INDICATOR_KEY: 'Carousel Indicator',
  HEADLINE_MARGIN_KEY: 'Headline Margin',
  TRANSPARENCY_KEY: 'Transparency',
  NAVIGATION_KEY: 'Navigation',
  MENU_SOURCE_KEY: 'Menu Source',
  PICKERS_KEY: 'Pickers',
  DATE_INPUT_KEY: 'Date Input',
  DOCKED_KEY: 'Docked',
  MIN_DATE_KEY: 'Min. Date',
  MAX_DATE_KEY: 'Max. Date',
  TIME_PICKER_KEY: 'Time Picker',
  TIME_VALUE_KEY: 'Time Value',
  ENABLE_INPUT_KEY: 'Enable Input',
  FORMAT_KEY: '24-Hour Format',
  PERIOD_BUTTON_KEY: 'Period Button',
  CLOCK_DIAL_KEY: 'Clock Dial',
  TIME_BUTTON_KEY: 'Time Button',
  INPUT_LABEL_KEY: 'Input Label',
  TIME_INPUT_KEY: 'Time Input',
  TABLES_KEY: 'Tables',
  DATA_TABLE_KEY: 'Data Table',
  HEADER_FOOTER_KEY: 'Header & Footer',
  BODY_KEY: 'Body',
  ODD_ROW_KEY: 'Odd Row',
  EVEN_ROW_KEY: 'Even Row',
  STRIPPED_ROWS_KEY: 'Stripped Rows',
  ROW_HEADER_KEY: 'Row Header',
  FOOTER_KEY: 'Footer',
  VERTICAL_BORDER_KEY: 'Vertical Border',
  HORIZONTAL_BORDER_KEY: 'Horizontal Border',
  ITEMS_PER_PAGE_KEY: 'Items Per Page',
  APPEARANCE_KEY: 'Appearance',
  SHOW_PAGINATION_KEY: 'Show Pagination',
  SHOW_COLUMN_TOGGLE_KEY: 'Show Column Toggle',
  SHOW_GLOBAL_FILTER_KEY: 'Show Global Filter',
  NO_DATA_MESSAGE_KEY: 'No Data Message',
  ON_ITEM_SELECT_KEY: 'On Item Select',
  SORTABLE_COLUMNS_KEY: 'Sortable Columns',
  ROW_SELECTION_KEY: 'Row Selection',
  SINGLE_ROW_KEY: 'Single Row',
  COLOR_1_KEY: 'Color 1',
  COLOR_2_KEY: 'Color 2',
  STYLE_VARIANT_KEY: 'Style Variant',
  COMPONENT_TITLE_ALIGNMENT_KEY: 'Align Component Title',
  TITLE_END_ALIGNED_KEY: 'Align Titles to Cell End',
  CONTENT_END_ALIGNED_KEY: 'Align Content to Cell End',
  BORDER_VARIANT_KEY: 'Border Variant',
  TABLE_CONTENT_KEY: 'Table Content',
  TEXT_KEY: 'Text',
  TEXT_COLOR_KEY: 'Text Color',
  TEXT_COLORS_OPTION_KEY: 'Text Colors Option',
  H1_KEY: 'H1',
  H2_KEY: 'H2',
  H3_KEY: 'H3',
  H4_KEY: 'H4',
  H5_KEY: 'H5',
  H6_KEY: 'H6',
  P_KEY: 'P',
  OL_KEY: 'OL',
  UL_KEY: 'UL',
  SOLID_COLOR_KEY: 'Solid Color',
  TEXT_COLOR_START_KEY: 'Start Color',
  TEXT_COLOR_END_KEY: 'End Color',
  TEXT_COLOR_GRADIENT_DIRECTION_KEY: 'Gradient Direction',
  SHOW_BORDER_KEY: 'Show Border',
  BORDER_TOP_KEY: 'Border Top',
  BORDER_END_KEY: 'Border End',
  BORDER_BOTTOM_KEY: 'Border Bottom',
  BORDER_START_KEY: 'Border Start',
  BORDER_WIDTH_KEY: 'Border Width',
  BORDER_COLOR_KEY: 'Border Color',
  BADGE_COLOR_KEY: 'Badge Color',
  BACKGROUND_CAPTION_KEY: 'Background Caption',
  BORDER_STYLE_KEY: 'Border Style',
  TEXT_ALIGNMENT_KEY: 'Text Alignment',
  RICH_TEXT_KEY: 'Rich Text',
  UPLOADS_KEY: 'Uploads',
  FILE_UPLOAD_KEY: 'File Upload',
  MAX_SIZE_KEY: 'Max. Size',
  ALLOWED_FILE_TYPES_KEY: 'Allowed File Types',
  IMAGE_UPLOAD_KEY: 'Image Upload',
  VISUAL_KEY: 'Visual',
  MAP_KEY: 'Map',
  COORDINATE_KEY: 'Coordinate',
  ON_MARKER_DROP_KEY: 'On Marker Drop',
  CHIP_COLOR_KEY: 'Chip Color',
  LINE_THICKNESS_KEY: 'Line Thickness',
  TEXT_STYLE_KEY: 'Text Style',
  LINEAR_PROGRESS_KEY: 'Linear Progress',
  CURRENT_VALUE_KEY: 'Current Value',
  TRACK_COLOR_KEY: 'Track Color',
  ACTIVE_INDICATOR_COLOR_KEY: 'Active Indicator Color',
  CIRCULAR_PROGRESS_KEY: 'Circular Progress',
  SHOW_VALUE_KEY: 'Show Value',
  SIZE_KEY: 'Size',
  SEARCH_KEY: 'Search',
  SEARCH_BOX_KEY: 'Search Box',
  FILTERS_KEY: 'Filters',
  FILTERS_BG_KEY: 'All Filters Overlay Background Color',
  FILTERS_CHIP_KEY: 'Filters Chip',
  ICON_SIZE_KEY: 'Icon Size',
  COLUMN_FILTER_KEY: 'Column Filter',
  BACKGROUND_COLOR_KEY: 'Background color',
  ACCENT_COLOR_KEY: 'Accent color',
  ITEM_BACKGROUND_KEY: 'Item Background',
  ITEM_BACKGROUND_OPACITY_KEY: 'Item Background Opacity',
  HIDDEN_FIELD_KEY: 'Hidden Field',
  DATA_ATTRIBUTE_KEY: 'Data Attribute',
  BUTTON_PADDING_KEY: 'Button Padding',
  SHOW_GRID_KEY: 'Show Grid',
  SHOW_AXIS_KEY: 'Show Axis',
  BUTTON_SIZE_KEY: 'Button Size',
  CART_OPTIONS_KEY: 'Cart Options',
  REDIRECTION_KEY: 'Redirection',
  REDIRECT_TO_KEY: 'Redirect To',
  ON_LOGIN_KEY: 'On Login',
  ON_LOGOUT_KEY: 'On Logout',
  TIMESTAMP_KEY: 'Timestamp',
  SHOW_SEARCH_RESULTS_INFO_KEY: 'Show Search Results Info',
  IMAGE_COMPRESSION_KEY: 'Image Compression',
  IMAGE_QUALITY_KEY: 'Image Quality',
  IMAGE_MAX_SIZE_KEY: 'Image Max Size',
  ADD_BUTTON_KEY: 'Add Button',
} as const
